var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _ellipse, _path41, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _path42, _path43, _path44, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmModalBot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 175,
    viewBox: "0 0 228 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.946 141.888C121.592 141.888 137.038 130.028 137.038 108.732C137.038 108.732 131.809 101.586 110.946 101.586C90.0825 101.586 84.8535 108.732 84.8535 108.732C84.8535 130.028 100.299 141.888 110.946 141.888Z",
    fill: "url(#paint0_linear_1224_205950)",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7105 108.767C87.7202 108.755 87.7335 108.738 87.7506 108.718C87.7926 108.667 87.8576 108.592 87.9479 108.496C88.1287 108.304 88.4112 108.027 88.8158 107.695C89.625 107.031 90.923 106.142 92.8726 105.253C96.7718 103.474 103.28 101.689 113.699 101.689C124.119 101.689 130.627 103.474 134.526 105.253C136.476 106.142 137.774 107.031 138.583 107.695C138.988 108.027 139.27 108.304 139.451 108.496C139.541 108.592 139.606 108.667 139.648 108.718C139.665 108.738 139.679 108.755 139.688 108.767C139.672 129.992 124.275 141.785 113.699 141.785C103.124 141.785 87.7274 129.992 87.7105 108.767Z",
    fill: "url(#paint1_linear_1224_205950)",
    stroke: "#A2A5D5",
    strokeWidth: 0.20614
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.15 140.829C98.5363 137.656 87.915 126.676 87.7134 109.238C89.3413 112.782 92.5548 114.866 95.8107 116.555C96.5669 116.947 97.3267 117.319 98.0701 117.683C98.1619 117.728 98.2535 117.772 98.3448 117.817C99.1756 118.224 99.9825 118.622 100.74 119.032C102.257 119.852 103.568 120.712 104.471 121.76C108.464 126.397 109.374 131.186 109.286 134.817C109.242 136.633 108.948 138.159 108.666 139.231C108.525 139.767 108.387 140.189 108.284 140.477C108.232 140.62 108.19 140.731 108.16 140.805C108.157 140.813 108.154 140.822 108.15 140.829Z",
    fill: "url(#paint2_linear_1224_205950)",
    stroke: "#A2A5D5",
    strokeWidth: 0.20614
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.25 140.829C128.864 137.656 139.485 126.676 139.687 109.238C138.059 112.782 134.846 114.866 131.59 116.555C130.833 116.947 130.074 117.319 129.33 117.683C129.238 117.728 129.147 117.772 129.056 117.817C128.225 118.224 127.418 118.622 126.66 119.032C125.143 119.852 123.832 120.712 122.93 121.76C118.936 126.397 118.027 131.186 118.115 134.817C118.158 136.633 118.452 138.159 118.734 139.231C118.875 139.767 119.014 140.189 119.117 140.477C119.168 140.62 119.211 140.731 119.24 140.805C119.244 140.813 119.247 140.822 119.25 140.829Z",
    fill: "url(#paint3_linear_1224_205950)",
    stroke: "#A2A5D5",
    strokeWidth: 0.20614
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7188 108.767C87.7284 108.754 87.7416 108.738 87.7584 108.718C87.8004 108.667 87.8654 108.592 87.9557 108.496C88.1364 108.304 88.4189 108.027 88.8234 107.695C89.6324 107.031 90.9301 106.142 92.8792 105.253C96.7775 103.474 103.284 101.689 113.701 101.689C124.119 101.689 130.625 103.474 134.524 105.253C136.473 106.142 137.77 107.031 138.579 107.695C138.984 108.027 139.266 108.304 139.447 108.496C139.537 108.592 139.602 108.667 139.644 108.718C139.661 108.738 139.674 108.754 139.684 108.767C139.672 109.22 139.428 109.67 138.967 110.114C138.495 110.568 137.806 111.006 136.942 111.423C135.215 112.256 132.813 112.994 130.121 113.606C124.74 114.831 118.226 115.553 113.701 115.553C109.176 115.553 102.663 114.831 97.2813 113.606C94.5902 112.993 92.1881 112.256 90.461 111.423C89.5972 111.006 88.9078 110.568 88.4357 110.114C87.9752 109.67 87.7305 109.22 87.7188 108.767Z",
    fill: "url(#paint4_linear_1224_205950)",
    stroke: "#A2A5D5",
    strokeWidth: 0.20614
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.78 109.483C123.296 109.483 132.825 107.031 132.825 104.61C132.825 104.61 125.937 101.73 113.78 101.73C101.624 101.73 95.1465 104.397 95.1465 104.397C95.1465 106.818 104.265 109.483 113.78 109.483Z",
    fill: "#667FE1",
    fillOpacity: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M113.666 115.372C122.613 115.372 139.409 112.601 139.409 108.731C139.409 108.731 138.909 113.739 113.666 113.739C88.4236 113.739 87.9238 108.731 87.9238 108.731C87.9238 112.601 104.72 115.372 113.666 115.372Z",
    fill: "url(#paint5_linear_1224_205950)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M121.67 118.077C120.177 118.218 117.983 117.691 117.902 116.831C117.902 116.831 118.581 116.272 121.474 115.998C124.367 115.725 125.138 116.146 125.138 116.146C125.217 116.977 123.163 117.936 121.67 118.077Z",
    fill: "url(#paint6_linear_1224_205950)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M128.651 131.096C130.327 129.011 133.215 126.448 133.442 126.631C133.669 126.813 131.931 129.892 129.964 132.267C127.997 134.642 125.543 136.811 125.378 136.679C125.214 136.546 126.976 133.181 128.651 131.096Z",
    fill: "url(#paint7_linear_1224_205950)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.1632 50.4975C83.5076 44.9881 78.8028 39.2925 71.5323 39.2925C63.3348 39.2925 62.4867 50.4193 63.0876 56.7848C61.2116 57.7928 60.4727 58.4838 60.4727 58.4838C60.4727 86.5991 86.2004 103.647 110.819 103.647C135.438 103.647 161.166 86.5991 161.166 58.4838C161.166 58.4838 160.429 57.7952 158.561 56.7901C159.144 50.4092 158.263 39.3952 150.107 39.3952C142.879 39.3952 138.187 45.0246 135.523 50.5038C128.941 49.6302 120.809 49.0492 110.819 49.0492C100.853 49.0492 92.7361 49.6274 86.1632 50.4975Z",
    fill: "url(#paint8_linear_1224_205950)",
    fillOpacity: 0.3
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M161.066 58.9946H135.804C136.123 56.4656 137.528 51.639 140.273 47.4199C143.061 43.1364 147.216 39.4986 153.003 39.4986C155.289 39.4986 156.991 40.3738 158.248 41.7711C159.508 43.1718 160.325 45.1016 160.824 47.2123C161.813 51.391 161.551 56.2443 161.066 58.9946Z",
    fill: "url(#paint9_linear_1224_205950)",
    stroke: "#A2A5D5",
    strokeWidth: 0.20614
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M160.986 58.5543C159.825 53.6199 156.075 49.2461 148.267 49.2461C144.435 49.2461 141.081 49.9567 138.17 51.1187V58.5543H160.986Z",
    fill: "url(#paint10_linear_1224_205950)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3635 58.8916H91.6259C91.3069 56.3626 89.902 51.536 87.1564 47.3169C84.3689 43.0334 80.2134 39.3956 74.4265 39.3956C72.1404 39.3955 70.4384 40.2708 69.1815 41.6681C67.9215 43.0687 67.105 44.9985 66.6055 47.1092C65.6167 51.288 65.8786 56.1413 66.3635 58.8916Z",
    fill: "url(#paint11_linear_1224_205950)",
    stroke: "#A2A5D5",
    strokeWidth: 0.20614
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3244 58.4517C67.486 53.5173 71.236 49.1436 79.0433 49.1436C82.8754 49.1436 86.2299 49.8542 89.1406 51.0162V58.4517H66.3244Z",
    fill: "url(#paint12_linear_1224_205950)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4703 58.53C63.4898 58.513 63.5182 58.4886 63.5559 58.4575C63.638 58.3897 63.7644 58.2896 63.94 58.1619C64.2912 57.9063 64.8391 57.54 65.6232 57.0996C67.1913 56.219 69.7038 55.0424 73.4749 53.865C81.0172 51.5102 93.5931 49.1524 113.714 49.1524C133.834 49.1524 146.41 51.5102 153.953 53.865C157.724 55.0424 160.236 56.219 161.804 57.0996C162.588 57.54 163.136 57.9063 163.487 58.1619C163.663 58.2896 163.789 58.3897 163.871 58.4575C163.909 58.4886 163.938 58.513 163.957 58.53C163.929 86.5426 138.282 103.545 113.714 103.545C89.145 103.545 63.4984 86.5426 63.4703 58.53Z",
    fill: "url(#paint13_linear_1224_205950)",
    stroke: "#A2A5D5",
    strokeWidth: 0.20614
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M164.061 58.4837C164.061 58.4837 162.57 57.5289 161.376 56.8149C161.981 67.7631 158.69 87.2413 133.977 99.8041C150.676 93.2847 164.061 78.7631 164.061 58.4837Z",
    fill: "#D185F2",
    fillOpacity: 0.3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3113 50.9982C86.3559 50.9852 86.421 50.967 86.5087 50.9442C86.7003 50.8945 86.9995 50.8232 87.4279 50.7374C88.2845 50.5658 89.6573 50.3365 91.7174 50.1071C95.8379 49.6483 102.707 49.189 113.694 49.189C124.682 49.189 131.554 49.6482 135.677 50.107C137.738 50.3363 139.112 50.5656 139.97 50.7371C140.399 50.8229 140.698 50.8942 140.89 50.944C140.978 50.9668 141.044 50.9851 141.088 50.9981C141.06 51.2307 140.9 51.4951 140.586 51.7846C140.242 52.1033 139.727 52.438 139.053 52.7775C137.707 53.4561 135.744 54.1447 133.289 54.7612C128.378 55.9938 121.511 56.9341 113.694 56.9341C105.878 56.9341 99.0135 55.9703 94.1057 54.726C91.6513 54.1037 89.6898 53.4121 88.3442 52.7378C87.6709 52.4005 87.1564 52.0696 86.8118 51.7572C86.4997 51.4742 86.3407 51.219 86.3113 50.9982Z",
    fill: "url(#paint14_linear_1224_205950)",
    stroke: "#A2A5D5",
    strokeWidth: 0.20614
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3001 51.5586C68.6579 54.3135 64.0078 58.6919 64.0078 58.6919C64.0078 80.2244 79.1778 95.186 97.2502 100.824C90.4453 91.9891 78.3283 69.7678 84.3001 51.5586Z",
    fill: "url(#paint15_linear_1224_205950)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M113.714 99.2476C131.908 99.2476 148.476 90.1572 151.796 74.3996C152.582 70.6726 150.78 67.0234 147.263 65.5604C141.937 63.3444 131.778 60.6812 113.714 60.6812C95.6503 60.6812 85.4914 63.3444 80.1653 65.5604C76.6486 67.0235 74.8453 70.6735 75.642 74.3981C78.9848 90.0262 95.538 99.2476 113.714 99.2476Z",
    fill: "url(#paint16_linear_1224_205950)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M144.321 66.66C139.138 64.6533 129.528 62.332 112.802 62.332C98.8362 62.332 89.8315 63.9502 84.2227 65.6525C89.3383 64.9566 100.832 65.005 103.817 72.7821C110.957 91.3857 123.231 94.2404 128.353 94.2404C131.416 94.2404 134.091 92.7309 134.35 92.5799C141.127 88.5401 146.742 82.7136 148.802 75.5383C149.876 71.7997 147.948 68.0644 144.321 66.66Z",
    fill: "url(#paint17_linear_1224_205950)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M113.714 64.7229C111.34 64.7229 107.963 64.0845 107.963 63.3308C107.963 63.3308 109.115 62.9014 113.714 62.9014C118.312 62.9014 119.465 63.3308 119.465 63.3308C119.465 64.059 116.087 64.7229 113.714 64.7229Z",
    fill: "url(#paint18_linear_1224_205950)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M156.224 66.5568C156.697 63.9242 158.602 60.3992 159.158 60.4992C159.715 60.5991 159.68 63.9146 159.048 66.9339C158.416 69.9533 156.972 73.2868 156.569 73.2143C156.166 73.1419 155.751 69.1894 156.224 66.5568Z",
    fill: "url(#paint19_linear_1224_205950)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M70.838 71.084C71.6799 73.6228 71.69 77.6297 71.1536 77.8075C70.6172 77.9854 69.0636 75.0563 68.1765 72.1018C67.2894 69.1474 66.9661 65.5288 67.355 65.3998C67.7438 65.2709 69.9961 68.5453 70.838 71.084Z",
    fill: "url(#paint20_linear_1224_205950)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M73.752 80.675C74.3435 81.7218 74.4219 83.6428 74.0771 83.8376C73.7324 84.0325 72.6723 82.9436 72.044 81.7066C71.4157 80.4696 71.1411 78.7987 71.391 78.6575C71.6409 78.5163 73.1604 79.6283 73.752 80.675Z",
    fill: "url(#paint21_linear_1224_205950)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M113.697 50.5656C122.106 50.5656 128.475 50.035 128.475 49.704C128.475 49.704 125.509 49.2866 113.697 49.2866C101.885 49.2866 98.9238 49.704 98.9238 49.704C98.9238 50.0218 105.287 50.5656 113.697 50.5656Z",
    fill: "url(#paint22_linear_1224_205950)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M106.158 77.2812C106.192 77.6026 106.215 77.928 106.227 78.2569L105.455 78.2842C105.46 78.4375 105.463 78.5915 105.463 78.7464C105.463 78.9013 105.46 79.0554 105.455 79.2086L106.227 79.236C106.215 79.5648 106.192 79.8902 106.158 80.2116L105.389 80.1291C105.356 80.4372 105.312 80.7413 105.258 81.0408L106.018 81.1789C105.96 81.5024 105.889 81.8211 105.808 82.1344L105.06 81.9406C104.982 82.2399 104.894 82.5338 104.796 82.8218L105.528 83.0713C105.422 83.382 105.305 83.6864 105.177 83.9839L104.467 83.6792C104.345 83.9625 104.213 84.2388 104.072 84.5077L104.757 84.8669C104.604 85.1576 104.441 85.4403 104.268 85.7142L103.615 85.3014C103.451 85.5611 103.277 85.8121 103.095 86.0539L103.713 86.5189C103.515 86.7809 103.308 87.033 103.092 87.2744L102.516 86.7587C102.312 86.9862 102.1 87.2033 101.88 87.4093L102.409 87.9735C102.17 88.1975 101.922 88.4096 101.665 88.609L101.19 87.999C100.951 88.1854 100.705 88.3595 100.451 88.5207L100.866 89.1728C100.591 89.3483 100.307 89.51 100.017 89.6571L99.6678 88.9675C99.3997 89.1033 99.1256 89.2254 98.846 89.333L99.1238 90.0544C98.8201 90.1714 98.5101 90.2728 98.1946 90.358L97.9931 89.6117C97.7057 89.6893 97.4134 89.7521 97.1168 89.7994L97.2386 90.5628C96.9189 90.6138 96.5945 90.6483 96.2662 90.6656L96.2256 89.8936C96.077 89.9014 95.9275 89.9053 95.7771 89.9053C95.6266 89.9053 95.4771 89.9014 95.3285 89.8936L95.2879 90.6656C94.9596 90.6483 94.6352 90.6138 94.3155 90.5628L94.4373 89.7994C94.1407 89.7521 93.8484 89.6893 93.561 89.6117L93.3595 90.358C93.044 90.2728 92.734 90.1714 92.4303 90.0544L92.7081 89.333C92.4285 89.2254 92.1544 89.1033 91.8864 88.9675L91.537 89.6571C91.2467 89.51 90.9634 89.3483 90.6877 89.1728L91.1028 88.5207C90.8496 88.3595 90.6029 88.1854 90.3636 87.999L89.8887 88.609C89.6326 88.4096 89.3846 88.1975 89.1455 87.9735L89.6739 87.4093C89.4539 87.2033 89.2417 86.9862 89.038 86.7587L88.4621 87.2744C88.2459 87.033 88.0388 86.7809 87.8415 86.5189L88.4589 86.0539C88.2768 85.8121 88.1035 85.5611 87.9395 85.3014L87.2859 85.7142C87.1129 85.4403 86.9498 85.1576 86.7973 84.8669L87.4818 84.5077C87.3407 84.2388 87.2091 83.9625 87.0876 83.6792L86.3771 83.9839C86.2496 83.6864 86.1325 83.382 86.0266 83.0713L86.7582 82.8218C86.66 82.5338 86.5718 82.2399 86.4943 81.9406L85.746 82.1344C85.6648 81.8211 85.5946 81.5024 85.5359 81.1789L86.2965 81.0408C86.2421 80.7413 86.1981 80.4372 86.165 80.1291L85.3964 80.2116C85.3619 79.8902 85.3386 79.5648 85.327 79.236L86.0995 79.2086C86.0941 79.0554 86.0914 78.9013 86.0914 78.7464C86.0914 78.5915 86.0941 78.4375 86.0995 78.2842L85.327 78.2569C85.3386 77.928 85.3619 77.6026 85.3964 77.2812L86.165 77.3637C86.1981 77.0556 86.2421 76.7515 86.2965 76.452L85.5359 76.3139C85.5946 75.9904 85.6648 75.6717 85.746 75.3584L86.4943 75.5523C86.5718 75.253 86.66 74.959 86.7582 74.671L86.0266 74.4215C86.1325 74.1108 86.2496 73.8064 86.3771 73.509L87.0876 73.8137C87.2091 73.5304 87.3407 73.254 87.4818 72.9851L86.7973 72.6259C86.9498 72.3352 87.1129 72.0526 87.2859 71.7786L87.9395 72.1914C88.1035 71.9318 88.2768 71.6807 88.4589 71.439L87.8415 70.9739C88.0388 70.7119 88.2459 70.4599 88.4621 70.2184L89.038 70.7341C89.2417 70.5066 89.4539 70.2895 89.6739 70.0835L89.1455 69.5193C89.3846 69.2953 89.6326 69.0833 89.8887 68.8838L90.3636 69.4938C90.6029 69.3075 90.8496 69.1333 91.1028 68.9721L90.6877 68.32C90.9634 68.1445 91.2467 67.9828 91.537 67.8357L91.8864 68.5253C92.1544 68.3895 92.4285 68.2675 92.7081 68.1598L92.4303 67.4384C92.734 67.3215 93.044 67.22 93.3595 67.1348L93.561 67.8811C93.8484 67.8035 94.1407 67.7407 94.4373 67.6934L94.3155 66.93C94.6352 66.879 94.9596 66.8445 95.2879 66.8273L95.3285 67.5992C95.4771 67.5914 95.6266 67.5875 95.7771 67.5875C95.9275 67.5875 96.077 67.5914 96.2256 67.5992L96.2662 66.8273C96.5945 66.8445 96.9189 66.879 97.2386 66.93L97.1168 67.6934C97.4134 67.7407 97.7057 67.8035 97.9931 67.8811L98.1946 67.1348C98.5101 67.22 98.8201 67.3215 99.1238 67.4384L98.846 68.1598C99.1256 68.2675 99.3997 68.3895 99.6678 68.5253L100.017 67.8357C100.307 67.9828 100.591 68.1445 100.866 68.32L100.451 68.9721C100.705 69.1333 100.951 69.3075 101.19 69.4938L101.665 68.8838C101.922 69.0833 102.17 69.2953 102.409 69.5193L101.88 70.0835C102.1 70.2895 102.312 70.5066 102.516 70.7341L103.092 70.2184C103.308 70.4599 103.515 70.7119 103.713 70.9739L103.095 71.439C103.277 71.6807 103.451 71.9318 103.615 72.1914L104.268 71.7786C104.441 72.0526 104.604 72.3352 104.757 72.6259L104.072 72.9851C104.213 73.254 104.345 73.5304 104.467 73.8137L105.177 73.509C105.305 73.8064 105.422 74.1108 105.528 74.4215L104.796 74.671C104.894 74.959 104.982 75.253 105.06 75.5523L105.808 75.3584C105.889 75.6717 105.96 75.9904 106.018 76.3139L105.258 76.452C105.312 76.7515 105.356 77.0556 105.389 77.3637L106.158 77.2812Z",
    stroke: "#8FDBFF",
    strokeWidth: 1.54605,
    strokeDasharray: "1.03 1.03"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M142.003 77.2812C142.038 77.6026 142.061 77.928 142.073 78.2569L141.3 78.2842C141.306 78.4375 141.308 78.5915 141.308 78.7464C141.308 78.9013 141.306 79.0554 141.3 79.2086L142.073 79.236C142.061 79.5648 142.038 79.8902 142.003 80.2116L141.235 80.1291C141.202 80.4372 141.158 80.7413 141.103 81.0408L141.864 81.1789C141.805 81.5024 141.735 81.8211 141.654 82.1344L140.906 81.9406C140.828 82.2399 140.74 82.5338 140.642 82.8218L141.373 83.0713C141.267 83.382 141.15 83.6864 141.023 83.9839L140.312 83.6792C140.191 83.9625 140.059 84.2388 139.918 84.5077L140.603 84.8669C140.45 85.1576 140.287 85.4403 140.114 85.7142L139.46 85.3014C139.296 85.5611 139.123 85.8121 138.941 86.0539L139.558 86.5189C139.361 86.7809 139.154 87.033 138.938 87.2744L138.362 86.7587C138.158 86.9862 137.946 87.2033 137.726 87.4093L138.254 87.9735C138.015 88.1975 137.767 88.4096 137.511 88.609L137.036 87.999C136.797 88.1854 136.55 88.3595 136.297 88.5207L136.712 89.1728C136.436 89.3483 136.153 89.51 135.863 89.6571L135.513 88.9675C135.245 89.1033 134.971 89.2254 134.692 89.333L134.97 90.0544C134.666 90.1714 134.356 90.2728 134.04 90.358L133.839 89.6117C133.551 89.6893 133.259 89.7521 132.963 89.7994L133.084 90.5628C132.765 90.6138 132.44 90.6483 132.112 90.6656L132.071 89.8936C131.923 89.9014 131.773 89.9053 131.623 89.9053C131.472 89.9053 131.323 89.9014 131.174 89.8936L131.134 90.6656C130.805 90.6483 130.481 90.6138 130.161 90.5628L130.283 89.7994C129.986 89.7521 129.694 89.6893 129.407 89.6117L129.205 90.358C128.89 90.2728 128.58 90.1714 128.276 90.0544L128.554 89.333C128.274 89.2254 128 89.1033 127.732 88.9675L127.383 89.6571C127.092 89.51 126.809 89.3483 126.533 89.1728L126.949 88.5207C126.695 88.3595 126.449 88.1854 126.209 87.999L125.734 88.609C125.478 88.4096 125.23 88.1975 124.991 87.9735L125.52 87.4093C125.3 87.2033 125.087 86.9862 124.884 86.7587L124.308 87.2744C124.092 87.033 123.884 86.7809 123.687 86.5189L124.305 86.0539C124.123 85.8121 123.949 85.5611 123.785 85.3014L123.132 85.7142C122.959 85.4403 122.796 85.1576 122.643 84.8669L123.327 84.5077C123.186 84.2388 123.055 83.9625 122.933 83.6792L122.223 83.9839C122.095 83.6864 121.978 83.382 121.872 83.0713L122.604 82.8218C122.506 82.5338 122.418 82.2399 122.34 81.9406L121.592 82.1344C121.511 81.8211 121.44 81.5024 121.382 81.1789L122.142 81.0408C122.088 80.7413 122.044 80.4372 122.011 80.1291L121.242 80.2116C121.208 79.8902 121.184 79.5648 121.173 79.236L121.945 79.2086C121.94 79.0554 121.937 78.9013 121.937 78.7464C121.937 78.5915 121.94 78.4375 121.945 78.2842L121.173 78.2569C121.184 77.928 121.208 77.6026 121.242 77.2812L122.011 77.3637C122.044 77.0556 122.088 76.7515 122.142 76.452L121.382 76.3139C121.44 75.9904 121.511 75.6717 121.592 75.3584L122.34 75.5523C122.418 75.253 122.506 74.959 122.604 74.671L121.872 74.4215C121.978 74.1108 122.095 73.8064 122.223 73.509L122.933 73.8137C123.055 73.5304 123.186 73.254 123.327 72.9851L122.643 72.6259C122.796 72.3352 122.959 72.0526 123.132 71.7786L123.785 72.1914C123.949 71.9318 124.123 71.6807 124.305 71.439L123.687 70.9739C123.884 70.7119 124.092 70.4599 124.308 70.2184L124.884 70.7341C125.087 70.5066 125.3 70.2895 125.52 70.0835L124.991 69.5193C125.23 69.2953 125.478 69.0833 125.734 68.8838L126.209 69.4938C126.449 69.3075 126.695 69.1333 126.949 68.9721L126.533 68.32C126.809 68.1445 127.092 67.9828 127.383 67.8357L127.732 68.5253C128 68.3895 128.274 68.2675 128.554 68.1598L128.276 67.4384C128.58 67.3215 128.89 67.22 129.205 67.1348L129.407 67.8811C129.694 67.8035 129.986 67.7407 130.283 67.6934L130.161 66.93C130.481 66.879 130.805 66.8445 131.134 66.8273L131.174 67.5992C131.323 67.5914 131.472 67.5875 131.623 67.5875C131.773 67.5875 131.923 67.5914 132.071 67.5992L132.112 66.8273C132.44 66.8445 132.765 66.879 133.084 66.93L132.963 67.6934C133.259 67.7407 133.551 67.8035 133.839 67.8811L134.04 67.1348C134.356 67.22 134.666 67.3215 134.97 67.4384L134.692 68.1598C134.971 68.2675 135.245 68.3895 135.513 68.5253L135.863 67.8357C136.153 67.9828 136.436 68.1445 136.712 68.32L136.297 68.9721C136.55 69.1333 136.797 69.3075 137.036 69.4938L137.511 68.8838C137.767 69.0833 138.015 69.2953 138.254 69.5193L137.726 70.0835C137.946 70.2895 138.158 70.5066 138.362 70.7341L138.938 70.2184C139.154 70.4599 139.361 70.7119 139.558 70.9739L138.941 71.439C139.123 71.6807 139.296 71.9318 139.46 72.1914L140.114 71.7786C140.287 72.0526 140.45 72.3352 140.603 72.6259L139.918 72.9851C140.059 73.254 140.191 73.5304 140.312 73.8137L141.023 73.509C141.15 73.8064 141.267 74.1108 141.373 74.4215L140.642 74.671C140.74 74.959 140.828 75.253 140.906 75.5523L141.654 75.3584C141.735 75.6717 141.805 75.9904 141.864 76.3139L141.103 76.452C141.158 76.7515 141.202 77.0556 141.235 77.3637L142.003 77.2812Z",
    stroke: "#8FDBFF",
    strokeWidth: 1.54605,
    strokeDasharray: "1.03 1.03"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M139.551 109.854C139.551 109.854 138.462 111.792 137.397 112.776C137.858 120.305 131.288 137.798 115.797 141.518C129.376 139.136 139.148 126.176 139.551 109.854Z",
    fill: "#D185F2",
    fillOpacity: 0.3
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7946 116.17C92.2232 118.964 90.5398 120.863 89.7848 120.644C89.0297 120.425 88.7732 119.964 88.2747 116.711C87.7761 113.459 87.7212 113.028 88.5376 112.508C89.354 111.987 91.3661 113.375 91.7946 116.17Z",
    fill: "url(#paint23_linear_1224_205950)",
    fillOpacity: 0.4
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M92.78 118.483C94.2627 124.027 93.7514 128.534 93.0078 127.909C92.2641 127.283 89.5287 121.43 88.6699 117.918C87.8112 114.405 87.7094 113.155 88.5175 112.527C89.3257 111.898 91.2973 112.938 92.78 118.483Z",
    fill: "url(#paint24_linear_1224_205950)",
    fillOpacity: 0.3
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M135.403 116.237C134.974 119.031 136.657 120.93 137.413 120.711C138.168 120.492 138.424 120.032 138.923 116.779C139.421 113.526 139.476 113.095 138.66 112.575C137.843 112.054 135.831 113.443 135.403 116.237Z",
    fill: "url(#paint25_linear_1224_205950)",
    fillOpacity: 0.4
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M134.417 118.55C132.935 124.095 133.446 128.602 134.19 127.976C134.933 127.351 137.669 121.498 138.527 117.985C139.386 114.472 139.488 113.223 138.68 112.594C137.872 111.966 135.9 113.005 134.417 118.55Z",
    fill: "url(#paint26_linear_1224_205950)",
    fillOpacity: 0.3
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M163.096 137.759C150.59 132.955 136.881 121.384 138.128 118.137C139.375 114.89 155.959 118.715 168.153 123.803C180.346 128.89 193.396 133.682 191.682 138.144C189.967 142.605 175.602 142.563 163.096 137.759Z",
    fill: "url(#paint27_linear_1224_205950)",
    fillOpacity: 0.3
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M162.823 134.679C150.317 129.875 136.608 118.304 137.855 115.057C139.102 111.81 155.686 115.635 167.879 120.722C180.073 125.81 193.123 130.602 191.408 135.064C189.694 139.525 175.329 139.483 162.823 134.679Z",
    fill: "url(#paint28_linear_1224_205950)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M167.884 120.453C180.057 125.481 193.057 130.283 191.564 134.169C191.564 134.169 191.936 130.905 168.058 121.66C140.486 110.983 138.428 114.527 138.428 114.527C139.514 111.699 155.711 115.426 167.884 120.453Z",
    fill: "#D185F2",
    fillOpacity: 0.3
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M162.823 134.679C175.329 139.483 189.694 139.525 191.408 135.063C191.668 134.388 191.589 133.706 191.227 133.016C191.227 133.016 184.956 134.105 172.35 132.675C155.238 130.733 149.484 127.447 148.35 126.687C148.275 126.633 148.2 126.58 148.126 126.526C148.126 126.526 148.195 126.583 148.35 126.687C152.687 129.788 157.85 132.768 162.823 134.679Z",
    fill: "url(#paint29_linear_1224_205950)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M168.736 125.28C165.818 124.209 162.044 121.653 162.215 121.188C162.386 120.722 166.119 121.576 169.457 122.884C172.794 124.191 176.401 126.294 176.277 126.631C176.153 126.969 171.654 126.352 168.736 125.28Z",
    fill: "url(#paint30_linear_1224_205950)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3744 137.759C76.8804 132.955 90.5897 121.384 89.3425 118.137C88.0953 114.89 71.5116 118.715 59.3182 123.803C47.1248 128.89 34.0745 133.682 35.7891 138.144C37.5036 142.605 51.8685 142.563 64.3744 137.759Z",
    fill: "url(#paint31_linear_1224_205950)",
    fillOpacity: 0.3
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6478 134.68C77.1538 129.876 90.8631 118.304 89.6159 115.057C88.3687 111.81 71.785 115.635 59.5916 120.723C47.3982 125.81 34.348 130.603 36.0625 135.064C37.777 139.525 52.1419 139.484 64.6478 134.68Z",
    fill: "url(#paint32_linear_1224_205950)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5872 120.453C47.4142 125.481 34.4133 130.283 35.9069 134.169C35.9069 134.169 35.535 130.905 59.4125 121.66C86.9851 110.983 89.043 114.527 89.043 114.527C87.9565 111.699 71.7602 115.426 59.5872 120.453Z",
    fill: "#D185F2",
    fillOpacity: 0.3
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6478 134.679C52.1418 139.483 37.7769 139.525 36.0624 135.063C35.803 134.388 35.8816 133.706 36.2439 133.016C36.2439 133.016 42.5146 134.105 55.1209 132.675C72.2326 130.733 77.9868 127.447 79.1211 126.687C79.1958 126.633 79.2703 126.58 79.3445 126.526C79.3445 126.526 79.2757 126.583 79.1211 126.687C74.7838 129.788 69.6206 132.768 64.6478 134.679Z",
    fill: "url(#paint33_linear_1224_205950)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M58.735 125.28C61.653 124.209 65.4271 121.653 65.2561 121.187C65.0851 120.722 61.3514 121.576 58.014 122.883C54.6766 124.191 51.0702 126.293 51.1941 126.631C51.318 126.968 55.817 126.351 58.735 125.28Z",
    fill: "url(#paint34_linear_1224_205950)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.428,
    cy: 162.408,
    rx: 31.6588,
    ry: 11.408,
    fill: "url(#paint35_radial_1224_205950)",
    fillOpacity: 0.4
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M113.715 26.373L113.715 48.7933",
    stroke: "url(#paint36_linear_1224_205950)",
    strokeWidth: 1.30481,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.539,
    cy: 25.5668,
    rx: 4.7184,
    ry: 4.56684,
    fill: "url(#paint37_linear_1224_205950)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 113.32,
    cy: 26,
    rx: 9.5,
    ry: 9,
    stroke: "url(#paint38_linear_1224_205950)",
    strokeWidth: 1.54011,
    strokeLinecap: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 113.32,
    cy: 26,
    rx: 13.5,
    ry: 13,
    stroke: "url(#paint39_linear_1224_205950)",
    strokeWidth: 1.54011,
    strokeLinecap: "round"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 113.32,
    cy: 26,
    rx: 17.5,
    ry: 17,
    stroke: "url(#paint40_linear_1224_205950)",
    strokeWidth: 1.54011,
    strokeLinecap: "round"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.15,
    cx: 113.32,
    cy: 26,
    rx: 21.5,
    ry: 21,
    stroke: "url(#paint41_linear_1224_205950)",
    strokeWidth: 1.54011,
    strokeLinecap: "round"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 113.32,
    cy: 26,
    rx: 25.5,
    ry: 25,
    stroke: "url(#paint42_linear_1224_205950)",
    strokeWidth: 1.54011,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M30.3055 41.1984L41.1258 39.3045C39.0108 31.4683 49.1372 27.3086 47.6169 18.6222C46.0205 9.50144 39.0391 6.99315 31.1042 8.38197C25.3333 9.39202 20.8374 13.0139 18.0122 17.6862L25.8826 22.7246C27.454 20.6591 28.813 19.0784 31.2656 18.6491C33.4296 18.2703 35.4826 18.9555 35.9387 21.5614C36.7495 26.1941 27.2157 32.0406 30.3055 41.1984ZM38.8869 58.7951C43.0708 58.0628 45.5177 54.2027 44.7829 50.0043C44.048 45.8059 40.4355 43.0064 36.2516 43.7386C32.0678 44.4709 29.6209 48.331 30.3557 52.5294C31.0905 56.7278 34.703 59.5273 38.8869 58.7951Z",
    fill: "#2F2DC1"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M13.3518 118.225L18.2909 115.417C15.8463 111.884 20.0383 108.068 17.7306 104.009C15.3075 99.7481 11.4483 99.7048 7.82631 101.764C5.1921 103.262 3.65087 105.839 3.11434 108.651L7.86339 109.799C8.25797 108.501 8.63622 107.48 9.75576 106.843C10.7436 106.282 11.8689 106.268 12.5612 107.486C13.792 109.65 10.1932 114.203 13.3518 118.225ZM20.7115 125.497C22.6213 124.411 23.1197 122.069 22.0043 120.108C20.8889 118.146 18.6213 117.377 16.7115 118.463C14.8017 119.549 14.3034 121.891 15.4188 123.852C16.5342 125.814 18.8017 126.583 20.7115 125.497Z",
    fill: "#2F2DC1"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M202.489 88.5402L212.644 90.2999C213.239 82.8424 223.494 82.4199 224.882 74.4124C226.338 66.0045 220.958 61.6357 213.511 60.3453C208.095 59.4068 202.984 61.133 199.019 64.295L204.388 71.1364C206.426 69.8399 208.124 68.8969 210.426 69.2958C212.457 69.6477 214.055 70.8869 213.639 73.2892C212.899 77.5598 202.638 79.6308 202.489 88.5402ZM204.539 106.491C208.466 107.171 211.841 104.595 212.512 100.724C213.182 96.854 210.871 93.2918 206.944 92.6113C203.017 91.9309 199.642 94.5077 198.971 98.378C198.3 102.248 200.612 105.811 204.539 106.491Z",
    fill: "#2F2DC1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1224_205950",
    x1: 137.038,
    y1: 119.515,
    x2: 81.0373,
    y2: 119.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DE0FF",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1224_205950",
    x1: 87.6074,
    y1: 112.808,
    x2: 139.791,
    y2: 112.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7EAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.149193,
    stopColor: "#C0E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519605,
    stopColor: "#D1D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87384,
    stopColor: "#C0E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9E8FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1224_205950",
    x1: 87.6074,
    y1: 119.568,
    x2: 107.821,
    y2: 126.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.693995,
    stopColor: "#C3DFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1224_205950",
    x1: 139.793,
    y1: 119.568,
    x2: 119.579,
    y2: 126.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.693995,
    stopColor: "#C3DFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1224_205950",
    x1: 87.6152,
    y1: 112.808,
    x2: 139.787,
    y2: 112.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7EAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00520833,
    stopColor: "#B7EAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.149193,
    stopColor: "#E9E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519605,
    stopColor: "#F8F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87384,
    stopColor: "#E9E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9E8FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1224_205950",
    x1: 113.034,
    y1: 113.163,
    x2: 112.96,
    y2: 115.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.336756,
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1224_205950",
    x1: 121.474,
    y1: 115.998,
    x2: 121.67,
    y2: 118.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771045,
    stopColor: "#CCD7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1224_205950",
    x1: 129.607,
    y1: 131.863,
    x2: 128.671,
    y2: 131.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1224_205950",
    x1: 161.166,
    y1: 67.922,
    x2: 53.1091,
    y2: 67.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DE0FF",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1224_205950",
    x1: 146.002,
    y1: 64.7589,
    x2: 154.625,
    y2: 39.3955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821767,
    stopColor: "#C0E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1224_205950",
    x1: 163.447,
    y1: 58.5543,
    x2: 138.17,
    y2: 50.6948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369241,
    stopColor: "#C2DEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687753,
    stopColor: "#B4CDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABBFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1224_205950",
    x1: 81.4282,
    y1: 64.6559,
    x2: 72.8049,
    y2: 39.2925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821767,
    stopColor: "#C0E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1224_205950",
    x1: 63.8638,
    y1: 58.4517,
    x2: 89.1406,
    y2: 50.5922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369241,
    stopColor: "#C2DEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687753,
    stopColor: "#B4CDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABBFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1224_205950",
    x1: 63.3672,
    y1: 63.8644,
    x2: 164.06,
    y2: 63.8644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7EAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.149193,
    stopColor: "#C0E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519605,
    stopColor: "#D1D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87384,
    stopColor: "#C0E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9E8FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1224_205950",
    x1: 86.2046,
    y1: 51.8002,
    x2: 141.184,
    y2: 51.8002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.149193,
    stopColor: "#BCBAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519605,
    stopColor: "#BBBAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87384,
    stopColor: "#97B1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91C5FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1224_205950",
    x1: 70.1139,
    y1: 80.931,
    x2: 84.9485,
    y2: 73.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3DFFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1224_205950",
    x1: 78.1693,
    y1: 81.3157,
    x2: 152.399,
    y2: 68.9814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C1DA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.470359,
    stopColor: "#3134D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1224_205950",
    x1: 106.044,
    y1: 78.2862,
    x2: 149.39,
    y2: 68.7532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#602DDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3134D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1224_205950",
    x1: 113.714,
    y1: 62.9014,
    x2: 113.714,
    y2: 64.7229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771045,
    stopColor: "#C7C5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1224_205950",
    x1: 158.564,
    y1: 66.9772,
    x2: 156.355,
    y2: 66.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1224_205950",
    x1: 67.9018,
    y1: 71.8458,
    x2: 70.8451,
    y2: 70.8106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.387196,
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1224_205950",
    x1: 72.3016,
    y1: 81.4948,
    x2: 73.4797,
    y2: 80.5095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1224_205950",
    x1: 114.295,
    y1: 50.5656,
    x2: 114.295,
    y2: 49.1544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.458744,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1224_205950",
    x1: 88.2736,
    y1: 116.705,
    x2: 91.794,
    y2: 116.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C1EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E2DDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1224_205950",
    x1: 88.417,
    y1: 117.847,
    x2: 91.97,
    y2: 117.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C1EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E2DDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1224_205950",
    x1: 138.924,
    y1: 116.772,
    x2: 135.403,
    y2: 116.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C1EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E2DDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1224_205950",
    x1: 138.78,
    y1: 117.914,
    x2: 135.227,
    y2: 117.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C1EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E2DDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1224_205950",
    x1: 137.733,
    y1: 119.167,
    x2: 194.999,
    y2: 141.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DE0FF",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1224_205950",
    x1: 138.582,
    y1: 114.926,
    x2: 191.563,
    y2: 133.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295244,
    stopColor: "#E4E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593241,
    stopColor: "#DBDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1224_205950",
    x1: 173.245,
    y1: 131.971,
    x2: 173.128,
    y2: 137.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DBFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7B5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1224_205950",
    x1: 169.455,
    y1: 123.321,
    x2: 168.948,
    y2: 125.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1224_205950",
    x1: 89.738,
    y1: 119.167,
    x2: 32.4714,
    y2: 141.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DE0FF",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1224_205950",
    x1: 88.8884,
    y1: 114.926,
    x2: 35.9076,
    y2: 133.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295244,
    stopColor: "#E4E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593241,
    stopColor: "#DBDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1224_205950",
    x1: 54.2257,
    y1: 131.971,
    x2: 54.3429,
    y2: 137.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DBFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7B5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1224_205950",
    x1: 58.0159,
    y1: 123.321,
    x2: 58.5223,
    y2: 125.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4FC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_1224_205950",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.428 162.408) rotate(90) scale(10.1211 28.0875)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AE7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#9AE7FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1224_205950",
    x1: 114.215,
    y1: 26.373,
    x2: 114.215,
    y2: 48.7933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92E8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509934,
    stopColor: "#C1E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D0FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1224_205950",
    x1: 113.539,
    y1: 21,
    x2: 113.539,
    y2: 30.1337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92E8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421216,
    stopColor: "#C2E0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2C9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1224_205950",
    x1: 113.32,
    y1: 17,
    x2: 113.32,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92E8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509934,
    stopColor: "#C1E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D0FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1224_205950",
    x1: 113.32,
    y1: 13,
    x2: 113.32,
    y2: 39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92E8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509934,
    stopColor: "#C1E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D0FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1224_205950",
    x1: 113.32,
    y1: 9,
    x2: 113.32,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92E8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509934,
    stopColor: "#C1E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D0FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1224_205950",
    x1: 113.32,
    y1: 5,
    x2: 113.32,
    y2: 47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92E8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509934,
    stopColor: "#C1E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D0FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1224_205950",
    x1: 113.32,
    y1: 1,
    x2: 113.32,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92E8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509934,
    stopColor: "#C1E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D0FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmModalBot);
export default __webpack_public_path__ + "static/media/confirm-modal-bot.7249c6bdfaa1c3514a3b18a4a18056a0.svg";
export { ForwardRef as ReactComponent };